import Section from 'components/Section'
import { motion } from 'framer-motion'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectNavigationTabById } from 'slices/Cms/Content/AppNavigation/BottomNav/selectors'
import { StateWithAppNavigation } from 'slices/Cms/Content/AppNavigation/types'
import { history } from 'store'
import Content from './Content'
import Controls from './Controls'
import Header from './Header'

type Props = {
  tabId: string | number
  index: number
  className?: string
}

const TabDescription: React.FC<Props> = ({ tabId, index, className = '' }) => {
  const tab = useSelector((state: StateWithAppNavigation) =>
    selectNavigationTabById(state, tabId)
  )

  // If tab doesn't exist, don't render anything
  if (!tab) {
    return null
  }

  const handleEdit = () => {
    history.push(`/brand_content/app_navigation/bottom_nav/edit/${tabId}`)
  }

  return (
    <motion.div
      className={`d-flex ${className}`}
      layout="position"
      transition={{
        type: 'spring',
        damping: 25,
        stiffness: 120,
      }}
    >
      <Section className="flex-1 mr-xs p-l">
        <Header index={index} onEdit={handleEdit} />
        <Content tab={tab} />
      </Section>
      <Controls tab={tab} />
    </motion.div>
  )
}

export default TabDescription
